<template>
  <div class="part-item projectBuilding">
    <p class="part-title">实验教学在线支持与服务
    </p>
    <div class="part-content">
      <span class="content-title">(1) 教学指导资源：</span>
      <div
        class="content-text"
        v-if="formInfo.online_support"
      >
        <div
          v-for="(item,index) in formInfo.online_support.teachChild"
          :key="index+'teach'"
        >
          <div
            class="teachItem"
            v-show="item.isSelect"
          >
            <p>{{item.title}}：</p>
            <a
              target="_blank"
              :href="file?file.path:'javascript:;'"
              :download="file?file.name:''"
              v-for="(file,key) in item.fileArry"
              :key="index + '-'+ key"
              class="link"
            >{{file.name}}</a>
          </div>
        </div>
      </div>
      <div
        class="content-text"
        v-else
      >暂无内容，请进行维护</div>
      <div class="clearfix"></div>
      <span class="content-title">(2) 实验指导资源：</span>
      <div
        class="content-text"
        v-if="formInfo.online_support"
      >
        <div
          v-for="(item,index) in formInfo.online_support.expChild"
          :key="index+'exp'"
        >
          <div
            class="teachItem"
            v-show="item.isSelect"
          >
            <p>{{item.title}}：</p>
            <template v-if="item.type==1">
              <a
                v-for="(file,key) in item.fileArry"
                :key="index + '-'+ key"
                class="link"
                :href="file?file.path:'javascript:;'"
                target="_blank"
                :download="file?file.name:''"
              >{{file.name}}</a>
            </template>
            <template v-if="item.type==2">
              <a
                :href="item.link"
                target="_blank"
                class="link"
              >{{item.link}}</a>
            </template>
          </div>
        </div>
      </div>
      <div
        class="content-text"
        v-else
      >暂无内容，请进行维护</div>
      <div class="clearfix"></div>
      <span class="content-title">(3) 在线教学支持方式：</span>
      <div
        class="content-text"
        v-if="formInfo.online_support"
      >
        <div
          v-for="(item,index) in formInfo.online_support.onlineteachChild"
          :key="index+'online'"
        >
          <div v-show="item.isSelect">
            <span>{{item.title}}：</span>
            <template v-if="item.type==1">
              <span>{{item.link}}</span>
            </template>
            <template v-else>
              <span style="margin-right:10px">{{item.link1}}</span>
              <span>{{item.link2}}</span>
            </template>
          </div>
        </div>
      </div>
      <div
        v-else
        class="content-text"
      >暂无内容，请进行维护</div>
      <div class="clearfix"></div>
      <span class="content-title">(4) <span class="NumCount">{{formInfo.online_support?formInfo.online_support.team:0}}</span>名提供在线教学服务的团队成员；<span class="NumCount">{{formInfo.online_support?formInfo.online_support.skill:0}}</span>名提供在线技术支持的技术人员；教学团队保证工作日期间提供<span class="NumCount">{{formInfo.online_support?formInfo.online_support.time:0}}</span>小时/日的在线服务</span>
      <div class="clearfix"></div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SupportAndServices',
  props: ['expId'],
  data() {
    return {
      formInfo: {}
    }
  },
  methods: {
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.online_support = data.online_support ? JSON.parse(data.online_support) : ''
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  async mounted() {
    await this.getInfo()
  }
}
</script>
<style scoped src="../../assets/css/project-manage.css"></style>
<style lang="less" scoped>
</style>
